
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { 
  Users, 
  Building, 
  Tag, 
  DollarSign, 
  UserCheck, 
  MessageSquare, 
  AlertTriangle,
  Webhook,
  Settings as SettingsIcon,
  List,
  Mail,
  FileText,
  Star
} from "lucide-react";

interface AdminNavigationProps {
  activeSection: string;
  onSectionChange: (section: string) => void;
}

const AdminNavigation = ({ activeSection, onSectionChange }: AdminNavigationProps) => {
  const navItems = [
    { 
      id: "assignments", 
      label: "User Assignments", 
      icon: Users,
      description: "Manage user-provider assignments"
    },
    { 
      id: "providers", 
      label: "Providers", 
      icon: Building,
      description: "Manage wellness providers"
    },
    { 
      id: "customers", 
      label: "Customers", 
      icon: Users,
      description: "Manage customer accounts"
    },
    { 
      id: "specialties", 
      label: "Specialties", 
      icon: Tag,
      description: "Manage provider specialties"
    },
    { 
      id: "finance", 
      label: "Finance", 
      icon: DollarSign,
      description: "Financial reports and analytics"
    },
    { 
      id: "admins", 
      label: "Admin Users", 
      icon: UserCheck,
      description: "Manage admin users"
    },
    { 
      id: "outreach", 
      label: "Outreach", 
      icon: MessageSquare,
      description: "Manage outreach contacts"
    },
    { 
      id: "feature-order", 
      label: "Feature Order", 
      icon: List,
      description: "Manage navigation feature order"
    },
    { 
      id: "errors", 
      label: "Error Logs", 
      icon: AlertTriangle,
      description: "View system error logs"
    },
    { 
      id: "webhooks", 
      label: "Webhooks", 
      icon: Webhook,
      description: "Test webhook endpoints"
    },
    { 
      id: "webhook-management", 
      label: "Webhook Management", 
      icon: SettingsIcon,
      description: "Manage webhook configurations & app settings"
    },
    {
      id: "email-logs",
      label: "Email Logs",
      icon: Mail,
      description: "Transactional email send history"
    },
    {
      id: "email-templates",
      label: "Email Templates",
      icon: FileText,
      description: "Preview and test email templates"
    },
    {
      id: "review-requests",
      label: "Review Requests",
      icon: Star,
      description: "Send review request emails to customers"
    },
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border p-4 mb-6">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeSection === item.id;
          
          return (
            <Button
              key={item.id}
              variant={isActive ? "default" : "outline"}
              size="sm"
              onClick={() => onSectionChange(item.id)}
              className={`h-auto p-3 flex flex-col items-center gap-2 relative ${
                isActive ? "bg-primary text-primary-foreground" : "hover:bg-gray-50"
              }`}
              title={item.description}
            >
              <Icon className="h-4 w-4" />
              <span className="text-xs font-medium text-center leading-tight">
                {item.label}
              </span>
              {item.id === "errors" && (
                <Badge variant="destructive" className="absolute -top-1 -right-1 h-5 w-5 p-0 flex items-center justify-center text-xs">
                  !
                </Badge>
              )}
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default AdminNavigation;
